import { useTranslation } from 'react-i18next';

function renderStars(n: number) {
  return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
}

export default function Comparison() {
  const { t } = useTranslation();

  const rows = [
    { name: t('comparison.r1'), best: t('comparison.r1best'), org: 5, updates: 5, beginner: 5 },
    { name: t('comparison.r2'), best: t('comparison.r2best'), org: 4, updates: 4, beginner: 5 },
    { name: t('comparison.r3'), best: t('comparison.r3best'), org: 4, updates: 4, beginner: 4 },
    { name: t('comparison.r4'), best: t('comparison.r4best'), org: 4, updates: 4, beginner: 5 },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{t('comparison.title')}</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">{t('comparison.subtitle')}</p>
        </div>

        <div className="mt-10 overflow-x-auto rounded-lg border border-background-200 bg-background-50">
          <table className="w-full min-w-[640px] text-sm">
            <thead>
              <tr className="bg-background-100 text-left text-foreground-700">
                <th className="px-5 py-3 font-semibold whitespace-nowrap">{t('comparison.col1')}</th>
                <th className="px-5 py-3 font-semibold whitespace-nowrap">{t('comparison.col2')}</th>
                <th className="px-5 py-3 font-semibold whitespace-nowrap">{t('comparison.col3')}</th>
                <th className="px-5 py-3 font-semibold whitespace-nowrap">{t('comparison.col4')}</th>
                <th className="px-5 py-3 font-semibold whitespace-nowrap">{t('comparison.col5')}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.name} className="border-t border-background-200">
                  <td className="px-5 py-4 font-semibold text-foreground-900 whitespace-nowrap">{r.name}</td>
                  <td className="px-5 py-4 text-foreground-700">{r.best}</td>
                  <td className="px-5 py-4 text-accent-600 whitespace-nowrap">{renderStars(r.org)}</td>
                  <td className="px-5 py-4 text-accent-600 whitespace-nowrap">{renderStars(r.updates)}</td>
                  <td className="px-5 py-4 text-accent-600 whitespace-nowrap">{renderStars(r.beginner)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}